/***
 * For use by people.js
 *
 * Utility functions to operate on the values of the _people set.
 */


"use strict";
/*
 Methods for the person objects
 */
export const create = function () {
    return {
        invitees: {},
        userProfiles: {},
        cache: {}
    };
};

/**
 * Check if a personObj represents a empty person
 * @param p
 * @returns {boolean}
 * @private
 */
export const isEmpty = function (p) {
    //If you have no objects backing you, you are a empty person.
    return (Object.keys(p.invitees).length + Object.keys(p.userProfiles).length <= 0);
};

export const linkInviteeKey = function (p, k) {
    p.invitees[k] = true;
};

export const unlinkInviteeKey = function (p, k) {
    delete p.invitees[k];
};

export const getInviteeKeys = function (p) {
    return Object.keys(p.invitees);
};

export const linkUserProfileKey = function (p, k) {
    p.userProfiles[k] = true;
};

export const unlinkUserProfileKey = function (p, k) {
    delete p.userProfiles[k];
};

export const getUserProfileKeys = function (p) {
    return Object.keys(p.userProfiles);
};

export const getCachedValue = function (p, key) {
    if (typeof key == "undefined" || !(key in p.cache)) {
        return; //undefined
    }

    //Note we use json so that we dont have to worry about mutation after storing in cache
    return JSON.parse(p.cache[key]);
};

export const setCachedValue = function (p, key, value) {
    if (typeof key == "undefined") {
        return;
    }
    if (typeof value == "undefined") {
        delete p.cache[key];
        return;
    }

    //Note we use json so that we dont have to worry about mutation after storing in cache
    p.cache[key] = JSON.stringify(value);
};

export const clearCache = function (p) {
    p.cache = {};
};
